/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const removeOutOfStockSizes = function() {
    if( typeof product_variants_removed != 'undefined' ) {  // was there items to be removed?
          product_variants_removed.forEach(function(item){
          const removedVarientInputs = Array.from(document.querySelectorAll('.SizeSwatchList .HorizontalList__Item input')).filter((node) => node.value === item);
  	      removedVarientInputs.forEach(inputElement => {
            inputElement.disabled = true;
      	  	let labelSizeElement = inputElement.nextElementSibling;
            while (labelSizeElement) {
             if (labelSizeElement.tagName === 'LABEL'){
            	labelSizeElement.style.position =  'relative';
				Array.from(labelSizeElement.children).forEach(childElement => {
					if(childElement.tagName === 'SPAN'){
              			childElement.style.display = 'inline';
            		}
          		})
                break
             }
             
              else {
            
                 	labelSizeElement = inputElement.nextElementSibling;
          		}
      			}
    		}
        	)}
          )}
		}
        
        
          document.addEventListener("DOMContentLoaded", removeOutOfStockSizes )